import LabServiceModel from "@/models/LabServiceModel";
import SampleModel from "@/models/lab/SampleModel";
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";

export default class ProcessScheduleSampleModel extends LabServiceModel {
  modelName() {
    return 'process-schedule-sample';
  }
  defaults() {
    return {
      id: null,
      process_schedule_id: null,
      process_schedule: null,
      sample_id: null,
      sample: null,
      order: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      process_schedule_id: (val) => (this.nullStringMutator(val)),
      sample_id: (val) => (this.nullStringMutator(val)),
      order: String,
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
  getProcessSchedule() {
    return this.getRelatedModel(ProcessScheduleModel, 'process_schedule')
  }
  getSample() {
    return this.getRelatedModel(SampleModel, 'sample');
  }

}
